import { lazy } from 'react';

import CustomLazyLoader from 'routes/CustomLazyLoader';

export const Signin = lazy(() => CustomLazyLoader(
  () => import('modules/auth/containers/Signin'), 'Signin',
));  

export const ForgotPassword = lazy(() => CustomLazyLoader(
  () => import('modules/auth/containers/ForgotPassword'), 'ForgotPassword',
)); 
